import { TipoActividad } from "../enums/TipoActividad";
import { TipoRecorrido } from "../enums/TipoRecorrido";
import Ruta from "../models/Ruta";

export const getRutas = () => {

    function generarRuta1() {
        return new Ruta(1, TipoActividad.senderismo, TipoRecorrido.gr, "Recorrido por la dehesa de griegos 1", "Es es la descripcion de la ruta 1");
    }

    function generarRuta2() {
        return new Ruta(2, TipoActividad.senderismo, TipoRecorrido.pr, "Recorrido por codes de griegos 2", "Es es la descripcion de la ruta 2");
    }

    function generarRuta3() {
        return new Ruta(3, TipoActividad.senderismo, TipoRecorrido.sl, "Recorrido por la dehesa de griegos 3", "Es es la descripcion de la ruta 3");
    }

    function generarRuta4() {
        return new Ruta(4, TipoActividad.senderismo, TipoRecorrido.gr, "Recorrido por la dehesa de griegos 4", "Es es la descripcion de la ruta 4");
    }

    function generarRuta5() {
        return new Ruta(5, TipoActividad.senderismo, TipoRecorrido.gr, "Recorrido por la dehesa de griegos 5", "Es es la descripcion de la ruta 5");
    }

    function generarRuta6() {
        return new Ruta(6, TipoActividad.senderismo, TipoRecorrido.pr, "Recorrido por la dehesa de griegos 6", "Es es la descripcion de la ruta 6");
    }

    function generarRuta7() {
        return new Ruta(7, TipoActividad.ciclismo, TipoRecorrido.pr, "Recorrido por la dehesa de griegos 7", "Es es la descripcion de la ruta 7");
    }

    function generarRuta8() {
        return new Ruta(8, TipoActividad.ciclismo, TipoRecorrido.sl, "Recorrido por la dehesa de griegos 8", "Es es la descripcion de la ruta 8");
    }

    function generarRuta9() {
        return new Ruta(9, TipoActividad.ciclismo, TipoRecorrido.gr, "Recorrido por la dehesa de griegos 9", "Es es la descripcion de la ruta 9");
    }

    function generarRuta10() {
        return new Ruta(10, TipoActividad.ciclismo, TipoRecorrido.gr, "Recorrido por la dehesa de griegos 10", "Es es la descripcion de la ruta 10");
    }

    
    const rutas: Ruta[] = [
        generarRuta1(),
        generarRuta2(),
        generarRuta3(),
        generarRuta4(),
        generarRuta5(),
        generarRuta6(),
        generarRuta7(),
        generarRuta8(),
        generarRuta9(),
        generarRuta10()
    ];

    return rutas;

} 